// pages/PasswordRecovery/RecoveryVerifyEmailOtpPage.tsx
import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { Button, OTPInput } from 'shared-portal-components-v2';

import { useRecoveryEmailOtp } from '@/hooks/auth/useRecoveryEmailOtp';
import { OTP_LENGTH } from '@/constants';

export default function RecoveryVerifyEmailOtpPage() {
  const { state, handlers } = useRecoveryEmailOtp();

  return (
    <div className="w-full max-w-md flex flex-col gap-8">
      <div className="text-center flex flex-col gap-2">
        <h1 className="text-3xl font-bold text-foreground">Verify your email</h1>
        <p className="text-muted-foreground text-lg">
          We've sent a {OTP_LENGTH}-digit verification code to your email. Please enter it
          below.
        </p>

        {state.globalError !== null && (
          <div className="rounded-md border border-destructive/40 bg-destructive/5 px-3 py-2 text-sm text-destructive">
            {state.globalError}
          </div>
        )}
      </div>

      <form onSubmit={handlers.handleSubmit} className="flex flex-col gap-6">
        <div className="flex justify-center">
          <OTPInput
            value={state.otp}
            onChange={handlers.handleOtpChange}
            numInputs={OTP_LENGTH}
            hasAutoFocus
            isDisabled={state.isLoading}
            inputClassName=""
            containerClassName="justify-center gap-3"
          />
        </div>

        <div className="flex flex-col gap-3">
          <Button
            type="submit"
            variant="primary"
            size="lg"
            className="w-full h-12 text-base font-semibold"
            isLoading={state.isLoading}
            disabled={state.isLoading || state.otp.length !== OTP_LENGTH}
          >
            Verify
          </Button>

          <div className="flex justify-between text-sm">
            <Button
              type="button"
              variant="link"
              className="p-0 h-auto text-muted-foreground hover:text-foreground gap-1"
              onClick={handlers.handleBack}
              disabled={state.isLoading}
            >
              <ArrowLeft className="w-4 h-4" />
              Back
            </Button>

            <Button
              type="button"
              variant="link"
              className="p-0 h-auto text-accent hover:text-accent/80"
              onClick={handlers.handleResend}
              disabled={state.isLoading}
            >
              Didn't receive the code? Resend
            </Button>
          </div>
        </div>
      </form>
    </div>
  );
}
